export default __webpack_public_path__ + "cu_light.6722c2c0.svg";